window.onload = () => {
  if(window.location.pathname == '/pages/evnement' || window.location.pathname == '/pages/formulaire-creation-de-compte') {
    const firstNameField = document.getElementById('RegisterForm-FirstName')
    const lastNameField = document.getElementById('RegisterForm-LastName')
    const emailField = document.getElementById('RegisterForm-email')
    const passwordField = document.getElementById('RegisterForm-password')

    const firstNameLabel = document.querySelector('label[for="RegisterForm-FirstName"]')
    const lastNameLabel = document.querySelector('label[for="RegisterForm-LastName"]')
    const emailLabel = document.querySelector('label[for="RegisterForm-email"]')
    const passwordLabel = document.querySelector('label[for="RegisterForm-password"]')

    firstNameField.addEventListener('focus', () => {
      firstNameLabel.style.background = 'white';
      firstNameLabel.style.top = '-10px';
      firstNameLabel.style.fontSize = '12px';
      firstNameLabel.style.transform = 'translateY(0)';
    })
    firstNameField.addEventListener('blur', () => {
      if(firstNameField.value.trim() == '') {
        firstNameLabel.style.background = 'transparent';
        firstNameLabel.style.transform = 'translateY(3px)';
        firstNameLabel.style.top = '10px';
        firstNameLabel.style.fontSize = '14px';
      }
    })

    lastNameField.addEventListener('focus', () => {
      lastNameLabel.style.background = 'white';
      lastNameLabel.style.top = '-10px';
      lastNameLabel.style.fontSize = '12px';
      lastNameLabel.style.transform = 'translateY(0)';
    })
    lastNameField.addEventListener('blur', () => {
      if(lastNameField.value.trim() == '') {
        lastNameLabel.style.background = 'transparent';
        lastNameLabel.style.transform = 'translateY(3px)';
        lastNameLabel.style.top = '10px';
        lastNameLabel.style.fontSize = '14px';
      }
    })

    emailField.addEventListener('focus', () => {
      emailLabel.style.background = 'white';
      emailLabel.style.top = '-10px';
      emailLabel.style.fontSize = '12px';
      emailLabel.style.transform = 'translateY(0)';
    })
    emailField.addEventListener('blur', () => {
      if(emailField.value.trim() == '') {
        emailLabel.style.background = 'transparent';
        emailLabel.style.transform = 'translateY(3px)';
        emailLabel.style.top = '10px';
        emailLabel.style.fontSize = '14px';
      }
    })

    passwordField.addEventListener('focus', () => {
      passwordLabel.style.background = 'white';
      passwordLabel.style.zIndex = '1';
      passwordLabel.style.top = '-10px';
      passwordLabel.style.fontSize = '12px';
      passwordLabel.style.transform = 'translateY(0)';
    })
    passwordField.addEventListener('blur', () => {
      if(passwordField.value.trim() == '') {
        passwordLabel.style.background = 'transparent';
        passwordLabel.style.transform = 'translateY(3px)';
        passwordLabel.style.top = '10px';
        passwordLabel.style.fontSize = '14px';
      }
    })

  }

  if(window.location.pathname == '/pages/formulaire-creation-de-compte') {
    const reasonField = document.getElementById('text-1635956597577')
    const phoneField = document.getElementById('phone-field')
    const vatField = document.getElementById('vat-validation')
    const addressField = document.getElementById('address-field')
    const cityField = document.getElementById('city-field')
    const zipField = document.getElementById('zip-field')
    const siretField = document.getElementById('text-1635956866273')

    const reasonLabel = document.querySelector('label[for="text-1635956597577"]')
    const phoneLabel = document.querySelector('label[for="phone-field"]')
    const vatLabel = document.querySelector('label[for="vat-validation"]')
    const addressLabel = document.querySelector('label[for="address-field"]')
    const cityLabel = document.querySelector('label[for="city-field"]')
    const zipLabel = document.querySelector('label[for="zip-field"]')
    const siretLabel = document.querySelector('label[for="text-1635956866273"]')

    addressField.addEventListener('focus', () => {
      addressLabel.style.background = 'white';
      addressLabel.style.top = '-10px';
      addressLabel.style.fontSize = '12px';
      addressLabel.style.transform = 'translateY(0)';
    })
    addressField.addEventListener('blur', () => {
      if(addressField.value.trim() == '') {
        addressLabel.style.background = 'transparent';
        addressLabel.style.transform = 'translateY(3px)';
        addressLabel.style.top = '10px';
        addressLabel.style.fontSize = '14px';
      }
    })
    cityField.addEventListener('focus', () => {
      cityLabel.style.background = 'white';
      cityLabel.style.top = '-10px';
      cityLabel.style.fontSize = '12px';
      cityLabel.style.transform = 'translateY(0)';
    })
    cityField.addEventListener('blur', () => {
      if(cityField.value.trim() == '') {
        cityLabel.style.background = 'transparent';
        cityLabel.style.transform = 'translateY(3px)';
        cityLabel.style.top = '10px';
        cityLabel.style.fontSize = '14px';
      }
    })
    zipField.addEventListener('focus', () => {
      zipLabel.style.background = 'white';
      zipLabel.style.top = '-10px';
      zipLabel.style.fontSize = '12px';
      zipLabel.style.transform = 'translateY(0)';
    })
    zipField.addEventListener('blur', () => {
      if(zipField.value.trim() == '') {
        zipLabel.style.background = 'transparent';
        zipLabel.style.transform = 'translateY(3px)';
        zipLabel.style.top = '10px';
        zipLabel.style.fontSize = '14px';
      }
    })
    
    reasonField.addEventListener('focus', () => {
      reasonLabel.style.background = 'white';
      reasonLabel.style.top = '-10px';
      reasonLabel.style.fontSize = '12px';
      reasonLabel.style.transform = 'translateY(0)';
    })
    reasonField.addEventListener('blur', () => {
      if(reasonField.value.trim() == '') {
        reasonLabel.style.background = 'transparent';
        reasonLabel.style.transform = 'translateY(3px)';
        reasonLabel.style.top = '10px';
        reasonLabel.style.fontSize = '14px';
      }
    })

    phoneField.addEventListener('focus', () => {
      phoneLabel.style.background = 'white';
      phoneLabel.style.top = '-10px';
      phoneLabel.style.fontSize = '12px';
      phoneLabel.style.transform = 'translateY(0)';
    })
    phoneField.addEventListener('blur', () => {
      if(phoneField.value.trim() == '') {
        phoneLabel.style.background = 'transparent';
        phoneLabel.style.transform = 'translateY(3px)';
        phoneLabel.style.top = '10px';
        phoneLabel.style.fontSize = '14px';
      }
    })

    vatField.addEventListener('focus', () => {
      vatLabel.style.background = 'white';
      vatLabel.style.top = '-10px';
      vatLabel.style.fontSize = '12px';
      vatLabel.style.transform = 'translateY(0)';
    })
    vatField.addEventListener('blur', () => {
      if(vatField.value.trim() == '') {
        vatLabel.style.background = 'transparent';
        vatLabel.style.transform = 'translateY(3px)';
        vatLabel.style.top = '10px';
        vatLabel.style.fontSize = '14px';
      }
    })

    siretField.addEventListener('focus', () => {
      siretLabel.style.background = 'white';
      siretLabel.style.zIndex = '1';
      siretLabel.style.top = '-10px';
      siretLabel.style.fontSize = '12px';
      siretLabel.style.transform = 'translateY(0)';
    })
    siretField.addEventListener('blur', () => {
      if(siretField.value.trim() == '') {
        siretLabel.style.background = 'transparent';
        siretLabel.style.transform = 'translateY(3px)';
        siretLabel.style.top = '10px';
        siretLabel.style.fontSize = '14px';
      }
    })

  }
}